<div class="forbidden-container" *transloco="let t">
  <div class="forbidden-content">
    <mat-icon class="forbidden-icon">block</mat-icon>
    <h1 class="forbidden-title">{{ t(title()) }}</h1>
    <p class="forbidden-message">{{ t(message()) }}</p>
  </div>
</div>
